import { render, staticRenderFns } from "./BKFConfigs.vue?vue&type=template&id=441ee124"
import script from "./BKFConfigs.vue?vue&type=script&lang=ts"
export * from "./BKFConfigs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports